import {
  ListItemIcon,
  ListItemText,
  MenuItem as MUIMenuItem,
  Tooltip,
} from '@mui/material';
import {bool, func, node, string} from 'prop-types';
import React from 'react';

const MenuItem = ({
  label,
  icon,
  color,
  disabled,
  onClick,
  tooltipText = '',
  ...props
}) => {
  const adjustedButtonProps = {
    disabled: disabled,
    component: disabled ? 'div' : undefined,
    onClick: disabled ? undefined : onClick,
    sx: {
      '&.Mui-disabled': {
        pointerEvents: 'auto',
      },
    },
  };

  return (
    <Tooltip title={tooltipText} placement="top">
      <MUIMenuItem {...props} {...adjustedButtonProps}>
        {icon && (
          <ListItemIcon
            sx={{
              color: theme =>
                color
                  ? (theme.vars || theme).palette[color].main
                  : (theme.vars || theme).palette.action.main,
              '& svg': {
                fontSize: '1.25rem',
              },
            }}
          >
            {icon}
          </ListItemIcon>
        )}
        <ListItemText
          sx={{
            color: theme =>
              color
                ? (theme.vars || theme).palette[color].main
                : 'text.primary',
          }}
        >
          {label}
        </ListItemText>
      </MUIMenuItem>
    </Tooltip>
  );
};

MenuItem.propTypes = {
  label: string,
  color: string,
  icon: node,
  disabled: bool,
  onClick: func,
  tooltipText: string,
};

export default MenuItem;
